export default "__VITE_ASSET__39d3e151__"